/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Firmwares Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    FlashedDevice,
} from './';

/**
 * @export
 * @interface ResponseModelFlash
 */
export interface ResponseModelFlash {
    /**
     * @type {string}
     * @memberof ResponseModelFlash
     */
    message?: string;
    /**
     * @type {string}
     * @memberof ResponseModelFlash
     */
    reason?: ResponseModelFlashReasonEnum;
    /**
     * @type {FlashedDevice}
     * @memberof ResponseModelFlash
     */
    data?: FlashedDevice;
}

/**
 * @export
 * @enum {string}
 */
export enum ResponseModelFlashReasonEnum {
    Ok = 'ok',
    Created = 'created',
    InvalidField = 'invalid_field',
    NoData = 'no_data',
    NotFound = 'not_found',
    NotImplemented = 'not_implemented',
    Restricted = 'restricted',
    ServerError = 'server_error'
}

